module.exports = __webpack_public_path__ + "img/5.986b1dca.png";